import {
  FETCH_HOME_INSIGHTS_HEATMAP,
  FETCH_HOME_INSIGHTS_SUMMARY,
  FETCH_HOME_INSIGHTS_LOCATIONS,
  FETCH_HOME_INSIGHTS_MOSTPOI,
  FETCH_HOME_INSIGHTS_ELECTORIAL,
  FETCH_HOME_INSIGHTS_SUBURBINFO,
  FETCH_HOME_INSIGHTS_BRANDAFFINITY,
  FETCH_HOME_INSIGHTS_WORK_LOCATIONS,
  DOWNLOAD_HOME_INSIGHTS,
} from '../constants';

export const fetchHomeInsightsHeatmap = () => ({
  type: FETCH_HOME_INSIGHTS_HEATMAP,
});

export const fetchHomeInsightsSummary = () => ({
  type: FETCH_HOME_INSIGHTS_SUMMARY,
});

export const fetchHomeInsightsLocations = () => ({
  type: FETCH_HOME_INSIGHTS_LOCATIONS,
});

export const fetchHomeInsightsMostPoi = () => ({
  type: FETCH_HOME_INSIGHTS_MOSTPOI,
});

export const fetchHomeInsightsElectorial = () => ({
  type: FETCH_HOME_INSIGHTS_ELECTORIAL,
});

export const fetchHomeInsightsSuburbInfo = () => ({
  type: FETCH_HOME_INSIGHTS_SUBURBINFO,
});

export const fetchHomeInsightsBrandAffinity = () => ({
  type: FETCH_HOME_INSIGHTS_BRANDAFFINITY,
});

export const fetchHomeInsightsWorkLocations = () => ({
  type: FETCH_HOME_INSIGHTS_WORK_LOCATIONS,
})

export const downloadHomeInsights = (csvType,reportType, fileName) => ({
  type: DOWNLOAD_HOME_INSIGHTS,
  csvType,
  reportType,
  fileName
});

